'use client';

import React, { ReactNode } from 'react';
import { Typography } from '../Typography';
import arrowUpIcon from '../../assets/icons/arrow-up.svg';
import { Box, BoxProps } from '../../wag-react/next-components/box';
import { Icon } from '../../wag-react/components/icon';
type Props = BoxProps & {
  children?: ReactNode;
};
export const ScrollToTop = ({
  children,
  ...rest
}: Props) => {
  const handleOnClick = () => {
    window.scrollTo(0, 0);
  };
  return <Box display="flex" alignItems="center" justifyContent="flex-end" {...rest} onClick={handleOnClick} data-sentry-element="Box" data-sentry-component="ScrollToTop" data-sentry-source-file="index.tsx">
      {children || <>
          <Icon src={arrowUpIcon} width="24px" height="24px" alt="arrow-up-icon" mr="4px" />
          <Typography>
            Top
          </Typography>
        </>}
    </Box>;
};
export type ScrollToTopProps = Props;